<template>
  <div />
</template>

<script>
import { connectSocket, postWebIOSocket, removeSocketInstance, socket } from '@/assets/js/socket.js'
import { tuiLog } from '@/assets/js/api.js'
import { CheckAndRefreshToken} from '@/axios/IUser.js'

const IntervalTime = 10000
const SocketNotifyCommonType = 40 // 监听通用类型
const SocketNotifyDeviceFailureChildType = 'DeviceStatus:Fault' // 设备故障子监听类型
export default {
  data () {
    return {
      checkStatusTime: null,
      checkRefreshTime: null
    }
  },
  computed:{
    socketmodel () {
      // 比较函数 需要监听的数据
      return this.$store.state.socketmodel
    }
  },
  watch: {
    '$route':function(e){
       /* user权限不触发设备故障的注册 & 每个页面都有removeall 的socketIO事件临时方案 */
       if(this.$store.state.userInfor.UserRole !== 4){
        this.socketListenDeivceFailure()
      }
    },
    socketmodel(rs){
      // console.log('rs: ', rs);
      this.tryDealFailureNotify(rs)
    }

  },
  mounted () {
    this.initializeSocket()
    // this.checkConnectionStatus()
    this.checkStatusTime = setInterval(this.checkConnectionStatus, 60*60*1000);
    /* 100分钟刷新token */
    this.doCheckAndRefreshToken()
   this.checkRefreshTime = setInterval(this.doCheckAndRefreshToken, 100*60*1000);
  },
  destroyed () {
    postWebIOSocket('sync_info_removeall_event')
    clearInterval(this.checkStatusTime)
    clearInterval(this.checkRefreshTime)
  },
  methods: {
    doCheckAndRefreshToken(){
      CheckAndRefreshToken({token:this.$store.state.token},(rs) => {
      })
    },
    checkConnectionStatus(){
      if (!socket || socket.disconnected) {
        this.reconnectSocket();
      }
    },
    reconnectSocket() {
      if (socket) {
        socket.disconnect();
        removeSocketInstance()
      }
      this.initializeSocket();
    },
    initializeSocket(){
        // 进行socket连接 获得用户信息 接收socket推送信息
      connectSocket(null, null, (connect) => {
        // /* user权限不触发设备故障的注册 */
        if(this.$store.state.userInfor.UserRole !== 4){
          this.socketListenDeivceFailure()
        }
      }, (disconnect) => {

      })
      // socket.on('sync_info_event', this.functionScoketsync_info_event)
    },
    /* 接收socket推送信息
     * rs：推送过来的数据包
     */
    // functionScoketsync_info_event (rs) {
    //   tuiLog('[WebIOSocket-data] ' + JSON.stringify(rs), 'socket')
    //   if (window.socketState) { window.socketState.className = 'socketOn socketShadow' }
    //   this.$store.dispatch('changeSocket', rs)
    //   if (localStorage != null) {
    //     setLocalStoragItem('tuiPage', JSON.stringify({ projectCode: this.$store.state.projectcode, data: rs }))
    //   }

    //   // 先暂时将解析故障放在这里， 因为目前所有socket推送，都是走这里。不敢动。
    //   this.tryDealFailureNotify(rs)
    // },
    // socket监听 设备故障
    socketListenDeivceFailure () {
        // 此处延时10s是因为子页面每次加载会移除一次所有监听，要避开这个移除
        const pid = this.$store.state.projectcode
        const param = {
          projectCode: pid,
          type: SocketNotifyCommonType,
          data: [{
            id: pid,
            idType: 'ProjectCode',
            notifyType: SocketNotifyDeviceFailureChildType
          }]
        }
        postWebIOSocket('sync_info_add_event', param)
    },
    tryDealFailureNotify (rs) {
      if (this.$store.state.deviceFaultConfig) {
        try {
          const res = rs ? rs.Result : {}
          if (res instanceof Array) {
            res.forEach((data) => {
              if (data.Type == SocketNotifyCommonType && data.NotifyType == SocketNotifyDeviceFailureChildType) {
                this.$store.commit('setHasWarning', true)
                const date = this.timeOffset(new Date(data.TimeStamp).toISOString())
                const type = data.Content.Status['0x0000']
                const desc = this.deiveStatusName('0x0000', type)
                const string = this.$t('failureLogs.failureRemind') + '：' + date + '</br>' + '' + data.Content.GpName + '  <strong>' + data.Content.DeviceName + ' </strong> ' + desc + '</br><div class="failurelog-go">' + this.$t('failureLogs.go') + '</div>'
                this.$notify({
                  title: this.$t('failureLogs.failureRemind'),
                  message: string,
                  dangerouslyUseHTMLString: true,
                  type: 'warning',
                  position: 'bottom-right',
                  duration: 5000,
                  customClass: 'failurelog',
                  onClick: () => {
                    // 侧边栏高亮
                    this.$store.state.routermsg = '/failureList'
                    this.$router.push({
                      path: '/failureList'
                    })
                  }
                })
              }
            })
          }
        } catch (err) {
          // console.log('tryDealFailureNotify err', err);
        }
      }
    }
  }
}

</script>

<style>
</style>
